import { useRequest } from 'ahooks'

import { createAuctionUnfreezeEnvironmentApplyApi } from '@eastcoal/api/trade/unfreezeApplyMember/createAuctionUnfreezeEnvironmentApply'

import { ConfirmButton } from '@eastcoal/common/components/Button/ConfirmButton'
import { useFeedback } from '@eastcoal/common/hooks/useFeedback'
import { pick } from '@eastcoal/common/utils/object'

import { useAuctionListStore } from '../../../Store/hooks/useStore'

import { DepositUnfreezeButtonProps } from './interface'

export const EnvDepositUnfreezeButton = ({
  record: { id, canReleaseEnvironmentDeposit }
}: DepositUnfreezeButtonProps) => {
  const { message } = useFeedback()

  const { tableRef } = useAuctionListStore(state => pick(state, ['tableRef']))

  const { loading, refresh } = useRequest(
    () =>
      createAuctionUnfreezeEnvironmentApplyApi({
        bizId: id
      }),
    {
      manual: true,
      onSuccess() {
        message.success('申请成功')
        tableRef.current?.reload()
      }
    }
  )

  return canReleaseEnvironmentDeposit ? (
    <ConfirmButton
      loading={loading}
      message='确定申请释放环保保证金吗？'
      type='link'
      onConfirm={refresh}
    >
      释放环保保证金
    </ConfirmButton>
  ) : null
}
